// extracted by mini-css-extract-plugin
export default {"memoCell":"InvoiceMemoCell_memoCell__clMYT","openButton":"InvoiceMemoCell_openButton__HbfzL"};